import { connect } from "react-redux";
import AlignmentInsights from "./AlignmentInsights";


const mapStateToProps = (state) => ({
    fetchRankDeltaApi: state.BenchmarkFilteringReducer.fetchRankDeltaApi,
    fetchBenchmarkAlignmentScoreApi: state.BenchmarkFilteringReducer.fetchBenchmarkAlignmentScoreApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(AlignmentInsights);
